/** Cohesive, code-native pixel icons shared by every web surface. */

const GARDEN_ICON_GLYPHS: Record<string, string> = {
  bell: '<path d="M7 16h10v-2h-1V9c0-3-2-5-4-5S8 6 8 9v5H7v2Zm3 2h4v2h-4z"/>',
  book: '<path d="M3 5h7c2 0 2 2 2 2s0-2 2-2h7v14h-7c-1 0-2 1-2 2 0-1-1-2-2-2H3V5Zm3 3v2h4V8H6Zm8 0v2h4V8h-4Zm-8 4v2h4v-2H6Zm8 0v2h4v-2h-4Z"/>',
  castle: '<path d="M3 4h4v4h3V4h4v4h3V4h4v6h-2v10H5V10H3V4Zm5 8v5h3v-5H8Zm5 0v8h3v-8h-3Z"/>',
  chart: '<path d="M3 19h18v2H3v-2Zm2-7h3v5H5v-5Zm5-5h3v10h-3V7Zm5 3h3v7h-3v-7Z"/>',
  chat: '<path d="M3 4h18v13H9l-5 4v-4H3V4Zm4 5v3h3V9H7Zm5 0v3h3V9h-3Zm5 0v3h2V9h-2Z"/>',
  check: '<path d="m3 12 4-4 4 4 7-7 3 3-10 10-8-6Z"/>',
  checkmark: '<path d="m3 12 4-4 4 4 7-7 3 3-10 10-8-6Z"/>',
  clipboard: '<path d="M8 3h8v2h4v16H4V5h4V3Zm2 2v2h4V5h-4ZM7 10v2h2v-2H7Zm4 0v2h6v-2h-6Zm-4 4v2h2v-2H7Zm4 0v2h6v-2h-6Z"/>',
  close: '<path d="m5 3 7 7 7-7 2 2-7 7 7 7-2 2-7-7-7 7-2-2 7-7-7-7 2-2Z"/>',
  cross: '<path d="m5 3 7 7 7-7 2 2-7 7 7 7-2 2-7-7-7 7-2-2 7-7-7-7 2-2Z"/>',
  flower: '<path d="M10 3h4v5h-4V3ZM4 8h5v4H4V8Zm11 0h5v4h-5V8ZM7 13h4v5H7v-5Zm6 0h4v5h-4v-5Zm-2-3h3v3h-3v-3Zm0 8h3v4h-3v-4Z"/>',
  footprints: '<path d="M6 3h4v7H6V3Zm-2 8h6v5H4v-5Zm10-3h4v7h-4V8Zm0 8h6v5h-6v-5Z"/>',
  group: '<path d="M4 5h6v6H4V5Zm10 0h6v6h-6V5ZM2 14h10v7H2v-7Zm10 0h10v7H12v-7Z"/>',
  guide: '<path d="M2 5h8c1 0 2 1 2 2 0-1 1-2 2-2h8v14h-8c-1 0-2 1-2 2 0-1-1-2-2-2H2V5Zm13 3v2h2v2h-2v3h2v-2h2V8h-4Zm0 9h2v-2h-2v2Z"/>',
  heart: '<path d="M2 8h3V5h5v3h4V5h5v3h3v5h-3v3h-3v3h-3v3h-2v-3H8v-3H5v-3H2V8Z"/>',
  hourglass: '<path d="M5 3h14v4l-4 5 4 5v4H5v-4l4-5-4-5V3Zm3 3 4 4 4-4H8Zm4 8-4 4h8l-4-4Z"/>',
  info: '<path d="M5 3h14v18H5V3Zm6 3v3h3V6h-3Zm0 5v7h3v-7h-3Z"/>',
  lightbulb: '<path d="M8 3h8v2h3v8h-3v3H8v-3H5V5h3V3Zm2 4v6h4V7h-4Zm-2 11h8v3H8v-3Z"/>',
  lightning: '<path d="M12 2h7l-5 7h5L8 22l3-9H5l7-11Z"/>',
  lock: '<path d="M7 3h10v3h2v5h2v10H3V11h2V6h2V3Zm2 3v5h6V6H9Zm2 9v3h2v-3h-2Z"/>',
  magnifier: '<path d="M4 3h10v2h3v3h2v6h-2v3h-3v2H8v-2H5v-3H3V8h1V3Zm4 3v2H6v6h2v2h6v-2h2V8h-2V6H8Zm9 10h2v2h2v3h-3v-2h-2v-2h1v-1Z"/>',
  palette: '<path d="M6 3h10v2h4v3h2v7h-3v3h-5v-4h-4v4H6v-2H3V8h2V5h1V3Zm1 4v3h3V7H7Zm7-1v3h3V6h-3Zm-8 6v3h3v-3H6Z"/>',
  plus: '<path d="M9 3h6v6h6v6h-6v6H9v-6H3V9h6V3Z"/>',
  quest: '<path d="M5 3h14v3h2v3h-2v12H5V9H3V6h2V3Zm3 4v2h8V7H8Zm0 5v2h2v-2H8Zm4 0v2h5v-2h-5Zm-4 4v2h2v-2H8Zm4 0v2h5v-2h-5Z"/>',
  refresh: '<path d="M6 5h10V2l5 5-5 5V9H8v2H4V7h2V5Zm12 8h2v4h-2v2H8v3l-5-5 5-5v3h8v-2h2Z"/>',
  robot: '<path d="M10 2h4v3h5v3h2v11h-3v3H6v-3H3V8h2V5h5V2ZM7 9v7h10V9H7Zm2 2h2v2H9v-2Zm4 0h2v2h-2v-2Zm-4 3v2h6v-2H9Z"/>',
  rock: '<path d="M7 5h9v2h3v4h2v7H3v-7h2V7h2V5Zm2 4v3h3V9H9Zm5 4v3h4v-3h-4Z"/>',
  sparkles: '<path d="M9 2h4v5h5v4h-5v5H9v-5H4V7h5V2Zm9 12h3v3h2v3h-2v3h-3v-3h-2v-3h2v-3ZM3 15h3v3H3v-3Z"/>',
  'sprout-large': '<path d="M10 21V11H8C4 11 2 8 2 4c4 0 8 1 10 5 2-4 6-5 10-5 0 4-2 7-6 7h-2v10h-4Z"/>',
  'sprout-small': '<path d="M10 21v-9H8c-4 0-6-3-6-7 5 0 8 2 10 6 2-4 5-6 10-6 0 4-2 7-6 7h-2v9h-4Z"/>',
  star: '<path d="M9 2h6v5h5v5h-3v3h-2v6H9v-6H7v-3H4V7h5V2Z"/>',
  thumbsup: '<path d="M9 3h5v6h6v3h2v7h-2v2H9V10h2V6H9V3ZM3 10h4v11H3V10Z"/>',
  trophy: '<path d="M5 3h14v3h3v7h-3v3h-5v3h4v3H6v-3h4v-3H5v-3H2V6h3V3Zm3 3v7h8V6H8ZM4 8v3h1V8H4Zm15 0v3h1V8h-1Z"/>',
  undo: '<path d="m3 9 6-6v4h6v2h3v3h2v7h-4v-6h-2v-2H9v4L3 9Z"/>',
  user: '<path d="M8 3h8v2h2v7h-2v2H8v-2H6V5h2V3Zm0 13h8v2h3v4H5v-4h3v-2Z"/>',
  warning: '<path d="M9 2h6v3h2v4h2v4h2v8H3v-8h2V9h2V5h2V2Zm2 7v6h3V9h-3Zm0 8v2h3v-2h-3Z"/>',
};

function glyphFor(name: string): string {
  if (name === 'server') return GARDEN_ICON_GLYPHS.castle!;
  return GARDEN_ICON_GLYPHS[name] ?? GARDEN_ICON_GLYPHS.info!;
}

function svgMarkup(name: string, size: number, extraStyle = ''): string {
  const snappedSize = Math.max(12, Math.round(size / 2) * 2);
  const style = [
    `width:${snappedSize}px`,
    `height:${snappedSize}px`,
    'display:inline-block',
    'flex:0 0 auto',
    'vertical-align:-0.15em',
    extraStyle.trim(),
  ].filter(Boolean).join(';');
  return `<svg class="garden-pixel-icon" viewBox="0 0 24 24" width="${snappedSize}" height="${snappedSize}" aria-hidden="true" focusable="false" style="${style}" shape-rendering="crispEdges"><g fill="currentColor">${glyphFor(name)}</g></svg>`;
}

export function gardenIcon(name: string, size: number, extraStyle = ''): string {
  return svgMarkup(name, size, extraStyle);
}

export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function preloadIcon(name: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" shape-rendering="crispEdges"><g fill="#9dea5a">${glyphFor(name)}</g></svg>`;
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
}
